//
// date-time-service.js
//
// Copyright (c) 2014 by Curalate, Inc.
//

/*global angular: false, moment: false */

// DateTime/TimeZone utilities. Depends on moment.js library.
(function() {
    'use strict';

    angular.module('curalate').factory('DateTimeService', ['SessionVarsService', '$sce',
        function(SessionVarsService, $sce) {
            var DATE_RANGE = {
                    'TODAY': 'T',
                    'LAST_WEEK': '7D',
                    'LAST_30_DAYS': '30D',
                    'LAST_3_MONTHS': '3M',
                    'ALL_TIME': 'AT',
                    'CUSTOM': 'C'
                },
                ISO_FORMAT_NO_TZ = 'YYYY-MM-DDTHH:mm:ss.SSS',
                ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ',
                userZoneId,
                userMoment,
                userNow;

            userZoneId = SessionVarsService.getTimeZoneId();

            userMoment = function(date, parseFormat) {
                var m = parseFormat ? moment.tz(date, parseFormat, userZoneId) : moment.tz(date, userZoneId);
                return m;
            };

            userNow = function() {
                return moment.tz(userZoneId).format();
            };

            return {
                DateRangeConstants: DATE_RANGE,

                // Returns the currently selected date range from the page.
                getDateRange: function() {
                    var dr = { from: undefined, to: undefined }; // Default to All-Time date range.
                    if (angular.element('#date-picker .xc_date-select').val() !== DATE_RANGE.ALL_TIME) {
                        dr = {
                            from: angular.element('.from-date-picker-input input').val(),
                            to: angular.element('.to-date-picker-input input').val()
                        }
                    }
                    return dr;
                },

                getDateRangeFromIdentifier: function(identifier, fromInclusive) {
                    var dateRange = {};

                    switch (identifier) {
                        case DATE_RANGE.TODAY: {
                            dateRange.from = dateRange.to = moment();
                            break;
                        }
                        case DATE_RANGE.LAST_WEEK: {
                            // default range: (one week from yesterday, yesterday]
                            dateRange.from = fromInclusive ? moment().subtract(1, 'week').subtract(1, 'day') : moment().subtract(1, 'week');
                            dateRange.to = moment().subtract(1, 'day');
                            break;
                        }
                        case DATE_RANGE.LAST_30_DAYS: {
                            // default range: (one month from yesterday, yesterday]
                            dateRange.from = fromInclusive ? moment().subtract(30, 'days').subtract(1, 'day') : moment().subtract(30, 'days');
                            dateRange.to = moment().subtract(1, 'day');
                            break;
                        }
                        case DATE_RANGE.LAST_3_MONTHS: {
                            // default range: (3 months from yesterday, yesterday]
                            dateRange.from = fromInclusive ? moment().subtract(3, 'months').subtract(1, 'day') : moment().subtract(3, 'months');
                            dateRange.to = moment().subtract(1, 'day');
                            break;
                        }
                        case DATE_RANGE.ALL_TIME: break;
                        case DATE_RANGE.CUSTOM: break;
                    }

                    return dateRange;
                },

                // Builds a dateRange query param from an object
                // The passed object should contain a "from" AND/OR a "to" field which can either be
                // moment objects, strings, or timestamps.
                buildDateRangeParam: function(dateRangeObject) {
                    var from, to;

                    if (dateRangeObject.from) {
                        if (!dateRangeObject.from._isAMomentObject) {
                            from = moment(new Date(dateRangeObject.from)).format('YYYY-MM-D');
                        } else {
                            from = dateRangeObject.from.format('YYYY-MM-D');
                        }
                    } else {
                        from = '';
                    }

                    if (dateRangeObject.to) {
                        if (!dateRangeObject.to._isAMomentObject) {
                            to = moment(new Date(dateRangeObject.to)).format('YYYY-MM-D');
                        } else {
                            to = dateRangeObject.to.format('YYYY-MM-D');
                        }
                    } else {
                        to = '';
                    }

                    if (from.length === 0 && to.length === 0) {
                        return '';
                    } else {
                        return from + '_' + to;
                    }
                },

                // Returns a moment representing the input date in the user's time zone.
                userMoment: userMoment,

                // Returns a moment representing now in the user's time zone.
                userNow: userNow,

                // Returns a moment representing the start of the day in the user's time zone
                userToday: function() {
                    return moment.tz(userZoneId).startOf('day');
                },

                userTomorrow: function() {
                    return moment.tz(userZoneId).startOf('day').add(1, 'days');
                },

                // Returns a moment representing the current hour
                roundNow: function() {
                    return moment().minutes(0).seconds(0).millisecond(0);
                },

                // Returns a moment with the same date components as the input date except with the browser's time zone component.
                applyBrowserTimeZone: function(date, parseFormat) {
                    var m = parseFormat ? moment(date, parseFormat) : moment(date),
                        noTimeZoneString = m.format(ISO_FORMAT_NO_TZ);
                    return moment(noTimeZoneString);
                },

                // Returns a moment with the same date components as the input date except with the user's time zone component.
                applyUserTimeZone: function(date, parseFormat) {
                    var m = parseFormat ? moment(date, parseFormat) : moment(date),
                        noTimeZoneString = m.format(ISO_FORMAT_NO_TZ);
                    return moment.tz(noTimeZoneString, userZoneId);
                },

                // Returns an formatted string.
                // If format not specified, uses an ISO format including milliseconds which is what our server serialization expects.
                formatUserMoment: function(date, format, parseFormat) {
                    var m = parseFormat ? userMoment(date, parseFormat) : userMoment(date);
                    if (format) {
                        return m.format(format);
                    } else {
                        return m.format(ISO_FORMAT);
                    }
                },

                // Exposes time zone related session variables, so most components don't need to reference both dependencies
                getFullTimeZoneName: function() {
                    return SessionVarsService.getTimeZoneFullName();
                },
                getShortTimeZoneName: function() {
                    return SessionVarsService.getTimeZoneShortName();
                },
                getTimeZoneId: function() {
                    return SessionVarsService.getTimeZoneId();
                },
                
                // Returns the delta in hours between a given time and the current time
                getHoursFromNow: function(date) {
                    return Math.round(moment.duration(moment.tz(userZoneId).diff(moment.tz(date, userZoneId))).asHours());
                }
            };
        }]);
})();